import React from 'react';
import { Translate } from 'react-localize-redux';
import { CONTRIBUTOR_ROLES } from '@webapp/utils/release/constants';
import CollaboratorsCtrl from '@webapp/controllers/track/collaborators';
import { UpdateCollaboratorsPlatforms } from '@webapp/controllers/track/collaborators/collaborator-list';
import { ContactInfo } from '@webapp/types/common/contact-info';
import { NewCollaborator } from '@services/collaborator/types/new-collaborator';

type CreditsTrackInfoProps = {
  trackId: string;
  collaborators?: UpdateCollaboratorsPlatforms[];
  songName: string;
  isShowErrors: boolean;
  canBeWithoutInvite: boolean;
  locked?: boolean;
  setCollaborators: (data: UpdateCollaboratorsPlatforms[]) => void;
  handleContributorContactChange: (newContact: ContactInfo) => void;
  contributorError: React.ReactNode;
  setContributorError: React.Dispatch<React.SetStateAction<React.ReactNode>>;
  setNewContributor: React.Dispatch<
    React.SetStateAction<NewCollaborator | undefined>
  >;
  setContributorName: React.Dispatch<React.SetStateAction<string>>;
};

export const CreditsTrackInfo = ({
  trackId,
  collaborators,
  songName,
  isShowErrors,
  canBeWithoutInvite,
  locked,
  setCollaborators,
  handleContributorContactChange,
  contributorError,
  setContributorError,
  setNewContributor,
  setContributorName,
}: CreditsTrackInfoProps) => {
  const onRemoveCollaborator = (id: string) => {
    if (collaborators) {
      setCollaborators(
        collaborators?.filter((col) => col.collaboratorId !== id)
      );
    }
  };
  return (
    <CollaboratorsCtrl
      id="creditDropdown"
      onChange={setCollaborators}
      onRemove={onRemoveCollaborator}
      label={<Translate id="RELEASE.TRACK_INFO.TRACK.CREDITS.TITLE" />}
      text={<Translate id="RELEASE.TRACK_INFO.TRACK.CREDITS.TEXT" />}
      assetId={trackId}
      forceEdit
      collaboratorType="CONTRIBUTOR"
      songName={songName}
      roleList={CONTRIBUTOR_ROLES}
      filterRepeated={false}
      showErrors={isShowErrors}
      inHalf
      handleEmailOrPhoneChange={handleContributorContactChange}
      showError={contributorError}
      setShowError={setContributorError}
      setNewCollaborator={setNewContributor}
      setCollaboratorName={setContributorName}
      canBeWithoutInvite={canBeWithoutInvite}
      hideEmailInput
      locked={locked}
    />
  );
};
